import {Model} from './model';
import {Relatable} from './relatable';
import {Person} from './person';

export class Entity implements Model, Relatable {
  id: number;
  created_at: Date;
  updated_at: Date;
  entityable_id: number;
  entityable_type: string;
  external_id: number;
  source: string;
  entityable: Person;
  meta: {
    latest_chat_message: string,
    latest_news_message: string,
    unread_chat_message_count: number,
    unread_news_message_count: number,
  };

  constructor(data?) {
    if (data != null) {
      this.fill(data);
    }
  }

  public fill(data) {
    this.id              = data['id'];
    this.created_at      = data['created_at'];
    this.updated_at      = data['updated_at'];
    this.entityable_id   = data['entityable_id'];
    this.entityable_type = data['entityable_type'];
    this.external_id     = data['external_id'];
    this.entityable      = data['entityable'];
    this.meta            = data['meta'];
  }

  public serialize() {
    return this;
  }

}
